import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { MantineMenu } from '@dealstack/frontend/shared/components/MantineMenu/MantineMenu.tsx';
import { SwitchSecurityRankDropdownStyles } from '@dealstack/frontend/shared/components/SecurityRankCard/SwitchSecurityRankDropdown.styles.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { GENERIC_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds.ts';
import { Text, useMantineTheme } from '@mantine/core';
import { MantineMenuItemProps } from '@dealstack/frontend/shared/components/MantineMenu/MantineMenu.types';

interface Props {
	ranks: MantineMenuItemProps[];
}

export const SwitchSecurityRankDropdown = ({ ranks }: Props) => {
	const tCapManage = useTranslationCapManage();
	const mantineTheme = useMantineTheme();

	return (
		<MantineMenu
			dataTestId={GENERIC_ELEMENT_ID.SWITCH_SECURITY_RANK_DROPDOWN}
			position="bottom-end"
			hideArrow={true}
			menuProps={{
				withinPortal: true,
			}}
			targetButtonProps={{
				style: {
					padding: 0,
				},
			}}
			targetContent={
				<SwitchSecurityRankDropdownStyles>
					<Icon
						variant="switch-arrows"
						size="lg"
						style={{
							color: mantineTheme.colors.dark[9],
						}}
					/>
				</SwitchSecurityRankDropdownStyles>
			}
			dropdownTopContent={
				<Text
					style={{ borderBottom: `1px solid ${mantineTheme.colors.gray[2]}` }}
					p="xs"
					c="gray.9"
				>
					{tCapManage('switchSecurityRankDropdown.title')}
				</Text>
			}
			items={ranks}
		/>
	);
};
